// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/connections/firstparty/v2/connection.proto

/* oxlint-disable */

/** Represents a deactivation source. */
export const ApiDeactivationSource = {
  /**
   * deactivation_source_unspecified - The deactivation source is not specified.
   */
  deactivation_source_unspecified: "deactivation_source_unspecified",
  /**
   * deactivation_source_mollie - Mollie is the source of deactivation
   */
  deactivation_source_mollie: "deactivation_source_mollie",
  /**
   * deactivation_source_qonto - Qonto is the source of deactivation
   */
  deactivation_source_qonto: "deactivation_source_qonto",
} as const;

export type ApiDeactivationSource = typeof ApiDeactivationSource[keyof typeof ApiDeactivationSource];

export namespace ApiDeactivationSource {
  export type deactivation_source_unspecified = typeof ApiDeactivationSource.deactivation_source_unspecified;
  export type deactivation_source_mollie = typeof ApiDeactivationSource.deactivation_source_mollie;
  export type deactivation_source_qonto = typeof ApiDeactivationSource.deactivation_source_qonto;
}

export function apiDeactivationSourceFromJSON(object: any): ApiDeactivationSource {
  switch (object) {
    case 0:
    case "deactivation_source_unspecified":
      return ApiDeactivationSource.deactivation_source_unspecified;
    case 1:
    case "deactivation_source_mollie":
      return ApiDeactivationSource.deactivation_source_mollie;
    case 2:
    case "deactivation_source_qonto":
      return ApiDeactivationSource.deactivation_source_qonto;
    default:
      return ApiDeactivationSource.deactivation_source_unspecified;
  }
}

export function apiDeactivationSourceToJSON(object: ApiDeactivationSource): string {
  switch (object) {
    case ApiDeactivationSource.deactivation_source_unspecified:
      return "deactivation_source_unspecified";
    case ApiDeactivationSource.deactivation_source_mollie:
      return "deactivation_source_mollie";
    case ApiDeactivationSource.deactivation_source_qonto:
      return "deactivation_source_qonto";
    default:
      return "deactivation_source_unspecified";
  }
}

/** Represents a connection status. */
export const ApiStatus = {
  /**
   * unspecified - The status is not specified.
   */
  unspecified: "unspecified",
  /**
   * not_connected - Connection is not set
   */
  not_connected: "not_connected",
  /**
   * pending - Connection is pending
   */
  pending: "pending",
  /**
   * enabled - Connection is enabled
   */
  enabled: "enabled",
  /**
   * disabled - Connection is disabled
   */
  disabled: "disabled",
} as const;

export type ApiStatus = typeof ApiStatus[keyof typeof ApiStatus];

export namespace ApiStatus {
  export type unspecified = typeof ApiStatus.unspecified;
  export type not_connected = typeof ApiStatus.not_connected;
  export type pending = typeof ApiStatus.pending;
  export type enabled = typeof ApiStatus.enabled;
  export type disabled = typeof ApiStatus.disabled;
}

export function apiStatusFromJSON(object: any): ApiStatus {
  switch (object) {
    case 0:
    case "unspecified":
      return ApiStatus.unspecified;
    case 1:
    case "not_connected":
      return ApiStatus.not_connected;
    case 2:
    case "pending":
      return ApiStatus.pending;
    case 3:
    case "enabled":
      return ApiStatus.enabled;
    case 4:
    case "disabled":
      return ApiStatus.disabled;
    default:
      return ApiStatus.unspecified;
  }
}

export function apiStatusToJSON(object: ApiStatus): string {
  switch (object) {
    case ApiStatus.unspecified:
      return "unspecified";
    case ApiStatus.not_connected:
      return "not_connected";
    case ApiStatus.pending:
      return "pending";
    case ApiStatus.enabled:
      return "enabled";
    case ApiStatus.disabled:
      return "disabled";
    default:
      return "unspecified";
  }
}

/** Represents a connection. */
export interface ApiConnection {
  /** Qonto organization ID */
  readonly organizationId: string;
  /** Bank account ID to link to the Mollie profile */
  readonly userBankAccountId: string;
  /** Mollie client link ID, used to identify the connection in Mollie */
  readonly clientLinkId: string;
  /** Location of the Mollie connection, e.g. "https://mollie.com/dashboard/locations/123456" */
  readonly mollieConnectionLocation?:
    | string
    | null
    | undefined;
  /** Status of the connection */
  readonly status: ApiStatus;
  /** deactivation source, e.g. "mollie", "qonto" */
  readonly deactivationSource?:
    | ApiDeactivationSource
    | null
    | undefined;
  /** Organizations capabilities information */
  readonly capabilities: ApiCapabilities | null;
}

/** Represents the capabilities of an organization's connection. */
export interface ApiCapabilities {
  /** Settlement capability details */
  readonly settlement: ApiSettlement | null;
}

/** Represents the organizations settlement capability */
export interface ApiSettlement {
  /** true if the organization has settlement enabled, false otherwise. */
  readonly isEnabled: boolean;
  /** Mollie redirect URL */
  readonly mollieRedirectUrl: string;
}

export const ApiConnection: MessageFns<ApiConnection> = {
  fromJSON(object: any): ApiConnection {
    return {
      organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "",
      userBankAccountId: isSet(object.user_bank_account_id) ? globalThis.String(object.user_bank_account_id) : "",
      clientLinkId: isSet(object.client_link_id) ? globalThis.String(object.client_link_id) : "",
      mollieConnectionLocation: isSet(object.mollie_connection_location)
        ? globalThis.String(object.mollie_connection_location)
        : null,
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.unspecified,
      deactivationSource: isSet(object.deactivation_source)
        ? apiDeactivationSourceFromJSON(object.deactivation_source)
        : null,
      capabilities: isSet(object.capabilities) ? ApiCapabilities.fromJSON(object.capabilities) : null,
    };
  },

  toJSON(message: ApiConnection): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    if (message.userBankAccountId !== undefined && message.userBankAccountId !== null) {
      obj.user_bank_account_id = message.userBankAccountId;
    }
    if (message.clientLinkId !== undefined && message.clientLinkId !== null) {
      obj.client_link_id = message.clientLinkId;
    }
    if (message.mollieConnectionLocation !== undefined && message.mollieConnectionLocation !== null) {
      obj.mollie_connection_location = message.mollieConnectionLocation;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.deactivationSource !== undefined && message.deactivationSource !== null) {
      obj.deactivation_source = apiDeactivationSourceToJSON(message.deactivationSource);
    }
    if (message.capabilities !== undefined && message.capabilities !== null) {
      obj.capabilities = ApiCapabilities.toJSON(message.capabilities);
    }
    return obj;
  },
};

export const ApiCapabilities: MessageFns<ApiCapabilities> = {
  fromJSON(object: any): ApiCapabilities {
    return { settlement: isSet(object.settlement) ? ApiSettlement.fromJSON(object.settlement) : null };
  },

  toJSON(message: ApiCapabilities): unknown {
    const obj: any = {};
    if (message.settlement !== undefined && message.settlement !== null) {
      obj.settlement = ApiSettlement.toJSON(message.settlement);
    }
    return obj;
  },
};

export const ApiSettlement: MessageFns<ApiSettlement> = {
  fromJSON(object: any): ApiSettlement {
    return {
      isEnabled: isSet(object.isEnabled) ? globalThis.Boolean(object.isEnabled) : false,
      mollieRedirectUrl: isSet(object.mollieRedirectUrl) ? globalThis.String(object.mollieRedirectUrl) : "",
    };
  },

  toJSON(message: ApiSettlement): unknown {
    const obj: any = {};
    if (message.isEnabled !== undefined && message.isEnabled !== null) {
      obj.isEnabled = message.isEnabled;
    }
    if (message.mollieRedirectUrl !== undefined && message.mollieRedirectUrl !== null) {
      obj.mollieRedirectUrl = message.mollieRedirectUrl;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
